import styled from "styled-components";
import { SkeletonPulse } from "../SkeletonPulse";

export const ProjectImageSkeleton = styled(SkeletonPulse)`
  width: ${({ theme }) => theme.downloadModal.projectImage.size};
  height: ${({ theme }) => theme.downloadModal.projectImage.size};
  margin: 0 ${({ theme }) => theme.downloadModal.projectImage.marginRight}
    ${({ theme }) => theme.downloadModal.projectImage.marginBottom} 0;
  flex: none;
`;

export const ProjectHeaderSkeleton = styled(SkeletonPulse)`
  height: ${({ theme }) => theme.p3r.fs};
  width: 55%;
  margin-bottom: ${({ theme }) => theme.spacing[4]};
`;

export const ProjectSelectSkeleton = styled(SkeletonPulse)`
  height: ${({ theme }) => theme.downloadModal.projectSelect.height};
  width: 100%;
  max-width: ${({ theme }) => theme.downloadModal.projectSelect.maxWidth};
  margin-bottom: ${({ theme }) => theme.spacing[3]};
`;

export const VarLine = styled(SkeletonPulse)`
  height: ${({ theme }) => theme.p3r.fs};
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing[4]};
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  flex: auto;

  .project-whatisit > p {
    color: ${({ theme }) => theme.textGrey};
    width: 140%;
  }

  .project-image,
  .select-project {
    margin: 0 ${({ theme }) => theme.downloadModal.projectImage.marginRight}
      ${({ theme }) => theme.downloadModal.projectImage.marginBottom} 0;
  }

  .project-image,
  .project-image-placeholder {
    border-radius: ${({ theme }) => theme.borderRadiusContainers};
    width: ${({ theme }) => theme.downloadModal.projectImage.size};
    height: ${({ theme }) => theme.downloadModal.projectImage.size};
    object-fit: cover;
    background-color: ${({ theme }) => theme.backgroundLight};
    flex: none;
  }

  .select-project {
    display: flex;
    flex-flow: column wrap;
    flex: auto;

    .select-header,
    .project-info,
    .project-select {
      margin-bottom: 10px;
      width: 100%;
      min-width: 100px;
    }

    .grey {
      color: ${({ theme }) => theme.textDark};
    }

    .underlined {
      text-decoration: underline;
    }

    .pointer {
      cursor: pointer;
    }

    .bold {
      font-family: AvenirLTPro-Heavy;
    }

    .project-info > p {
      color: ${({ theme }) => theme.textGrey};
    }

    .btn-text {
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .ant-radio-group .ant-radio-wrapper {
    color: ${props => props.theme.textLight};
  }
  .ant-radio-group .ant-radio-wrapper-checked {
    color: ${props => props.theme.textLight};
  }

  .ant-radio-group .ant-radio-wrapper .ant-radio-inner {
    background: ${props => props.theme.backgroundLight};
    border-color: ${props => props.theme.grey2};
  }

  .ant-radio-group .ant-radio-wrapper-checked .ant-radio-inner {
    background: ${props => props.theme.highlight};
    border-color: ${props => props.theme.highlight};
  }

  .ant-radio-group .ant-radio-checked .ant-radio-inner::after {
    background: ${props => props.theme.textLight};
  }

  .ant-radio-group .ant-radio-disabled + span {
    color: ${props => props.theme.textLight};
  }
`;
